import {Button as MuiButton} from "@material-ui/core";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import Box from "@mui/material/Box";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import React, {FC} from "react";
import {styled, Tooltip} from "@mui/material";

const Button = styled(MuiButton)`
  max-height: 51px;
  padding: 0;
  min-width: 40px;
`

type PropsType = {
  value: string;
  onChange: (value: string) => void
}

const MarginChanger: FC<PropsType> = ({
  value,
  onChange
}) => {

  const incrementNumberAtIndex = (array: string[], index: number, increment: number = 1) => {
    const value = array[index];
    if (!value) {
      array[index] = `${increment}px`;
    } else {
      if (!value.includes('px')) {
        array[index] = `${value}px`;
      } else {
        // @ts-ignore
        const number = parseInt(value.match(/\d+/)[0]);
        const updatedNumber = number + increment;
        array[index] = `${value.replace(/\d+/, updatedNumber.toString())}`;
      }
    }
    return array.join(' ')
  }


  const handleChange = (variant: 'top' | 'left' | 'bottom' | 'right') => {
    let initialValue: string[] = ['0px', '0px', '0px', '0px']
    const values = value.split(' ')
    if (values.length > 3) {
      initialValue = values
    }

    switch (variant) {
      case 'top':
        onChange(incrementNumberAtIndex(initialValue, 0))
        break
      case 'right':
        onChange(incrementNumberAtIndex(initialValue, 1))
        break
      case 'bottom':
        onChange(incrementNumberAtIndex(initialValue, 2))
        break
      case 'left':
        onChange(incrementNumberAtIndex(initialValue, 3))
        break
      default:
        break
    }
  }

  return (
    <Box display={'flex'} ml={2}>
      <Tooltip title={'Margin left'} placement={'top'} arrow>
        <Button
          variant={'outlined'}
          onClick={() => handleChange('left')}
          style={{borderRadius: '4px 0 0 4px', borderRight: 0}}
        ><ArrowLeftIcon/></Button>
      </Tooltip>
      <Box display={'flex'} flexDirection={'column'}>
        <Tooltip title={'Margin top'} placement={'top'} arrow>
          <Button
            variant={'outlined'}
            onClick={() => handleChange('top')}
            style={{borderRadius: 0, borderBottom: 0}}
          ><ArrowDropUpIcon/></Button>
        </Tooltip>
        <Tooltip title={'Margin bottom'} placement={'top'} arrow>
          <Button
            variant={'outlined'}
            onClick={() => handleChange('bottom')}
            style={{borderRadius: 0}}
          ><ArrowDropDownIcon/></Button>
        </Tooltip>
      </Box>
      <Tooltip title={'Margin right'} placement={'top'} arrow>
        <Button
          variant={'outlined'}
          onClick={() => handleChange('right')}
          style={{borderRadius: '0 4px 4px 0', borderLeft: 0}}
        ><ArrowRightIcon/></Button>
      </Tooltip>
    </Box>
  )
}

export default MarginChanger